<template>
	<li class="tap-tips">
		<span>{{ text }}</span>
		<tool-tip :visiable="visiable" :content="content" class="tip-message">
			<span
				ref="tipIcon"
				class="tip-icon"
				:style="
					color
						? {
								color,
								borderColor: color,
						  }
						: ''
				"
				@mousemove="visiable = true"
				@mouseout="visiable = false"
				@click="visiable = true"
				>!</span
			>
		</tool-tip>
	</li>
</template>
<script>
import buyStore from '../../buyStore'
export default {
	data() {
		return {
			visiable: false,
		}
	},
	mounted() {
		buyStore.$on('bodyClicked', e => {
			this.closeTip(e)
		})
	},
	methods: {
		closeTip(e) {
			if (e.target !== this.$refs.tipIcon) {
				this.visiable = false
			}
		},
	},
	props: {
		text: String,
		content: String,
		color: {
			type: String,
		},
	},
}
</script>
<style lang="scss" scoped>
.tap-tips {
	position: relative;
}
.tip-message {
	display: inline-block;
	margin-left: 4px;
	line-height: 100%;
	cursor: pointer;
}
.tip-icon {
	display: block;
	text-align: center;
	height: 12px;
	width: 12px;
	border: 1px solid #fff;
	border-radius: 50%;
	cursor: pointer;
}
</style>
